import { Music } from 'lucide-react'
import type { ReactNode } from 'react'

export interface AuthLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
  /** Rendered under the card, e.g. the link to the other auth page. */
  footer?: ReactNode
}

/**
 * The shell both auth pages share: wordmark, one centred card, full height.
 * Neither page is inside AppShell, so this owns its own background and padding.
 */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-surface-sunken px-4 py-10">
      <main className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center gap-6">
        <div className="flex items-center justify-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent">
            <Music className="h-6 w-6 text-on-accent" aria-hidden="true" />
          </span>
          <span className="text-2xl font-semibold tracking-tight text-text">Tunes</span>
        </div>

        <div className="rounded-card border border-border bg-surface-raised p-5 sm:p-6">
          <div className="mb-5 flex flex-col gap-1">
            <h1 className="text-lg font-semibold text-text">{title}</h1>
            {subtitle ? <p className="text-sm text-text-muted">{subtitle}</p> : null}
          </div>

          {children}
        </div>

        {footer ? <div className="text-center text-sm text-text-muted">{footer}</div> : null}
      </main>
    </div>
  )
}
